module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pane-box"
  }, [_c('div', {
    staticClass: "pane-label"
  }, [_c('div'), _vm._v(_vm._s(_vm.label) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-472e0d46","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseTag/index.vue
// module id = 647
// module chunks = 0